package navigation.home.proposal.allproposal

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import cafe.adriel.voyager.navigator.Navigator
import cafe.adriel.voyager.navigator.tab.TabOptions
import cafe.adriel.voyager.transitions.SlideTransition
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.esIconPainterResource
import navigation.utils.NavLinkTab

object AllProposalScreenTab : NavLinkTab {

    override var innerNavigator: Navigator? by mutableStateOf(null)

    override val options: TabOptions
        @Composable
        get() {
            val title = "Proposals"
            val icon = esIconPainterResource(EsIcons.Proposal)
            val index: UShort = 2u

            return TabOptions(
                index, title, icon,
            )
        }

    @Composable
    override fun Content() {
        Navigator(AllProposalScreenNav) { navigator ->

            DisposableEffect(navigator) {
                innerNavigator = navigator

                onDispose {
                    innerNavigator = null
                }
            }

            SlideTransition(navigator)
        }
    }
}